module.exports = __webpack_public_path__ + "static/media/spartacus_icon.a630ddf2.svg";